import request from '@/utils/request';

// 根据门店和时间查询会员注册人数
export function getMemberCount(values) {
  return request('/ec/member-report/queryRegisterMemberCount', {
    method: 'POST',
    data: values,
  });
}

// 根据门店和时间查询订单金额
export function getOrderAmount(values) {
  return request('/ec/member-report/queryOrderAmount', {
    method: 'POST',
    data: values,
    // data: {
    //   tradeTimeEnd: values.signupDateEnd,
    //   tradeTimeStart: values.signupDateStart,
    //   store: values.store,
    // },
  });
}
// 根据门店和时间查询订单销售明细列表
export function getOrderSalesList(values) {
  return request('/ec/member-report/queryOrderSales', {
    method: 'POST',
    data: values,
  });
}
